import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const OCCUPATION_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: [
    'Accountant',
    'Actor',
    'Architect',
    'Artist',
    'Baker',
    'Banker',
    'Barber',
    'Bartender',
    'Businessman',
    'Chef',
    'Civil Engineer',
    'Dentist',
    'Doctor',
    'Electrician',
    'Engineer',
    'Farmer',
    'Firefighter',
    'Graphic Designer',
    'Journalist',
    'Lawyer',
    'Librarian',
    'Mechanic',
    'Musician',
    'Nurse',
    'Pharmacist',
    'Photographer',
    'Pilot',
    'Plumber',
    'Police Officer',
    'Professor',
    'Programmer',
    'Scientist',
    'Software Developer',
    'Teacher',
    'Veterinarian',
    'Writer',
    'Indian Administrative Service (IAS) Officer',
    'Indian Police Service (IPS) Officer',
    'Indian Foreign Service (IFS) Officer',
    'Indian Revenue Service (IRS) Officer',
    'Indian Forest Service (IFoS) Officer',
    'Public Sector Undertaking (PSU) Employee',
    'Defense Personnel (Army, Navy, Air Force)',
    'Scientist at Indian Space Research Organisation (ISRO)',
    'Scientist at Defence Research and Development Organisation (DRDO)',
    'Government School Teacher',
    'Professor at Government University',
    'Doctor in Government Hospital',
    'Engineer in Public Works Department (PWD)',
    'Bank Officer in Public Sector Bank',
    'Railway Officer',
    'Customs Officer',
    'Central Bureau of Investigation (CBI) Officer',
    'Income Tax Officer',
    'Public Sector Unit (PSU) Executive',
    'Municipal Corporation Employee',
    'Bank Teller',
    'Loan Officer',
    'Credit Analyst',
    'Branch Manager',
    'Financial Analyst',
    'Relationship Manager',
    'Investment Banker',
    'Mortgage Advisor',
    'Risk Manager',
    'Compliance Officer',
    'Treasury Analyst',
    'Personal Banker',
    'Bank Clerk',
    'Financial Planner',
    'Operations Manager',
    'Customer Service Representative',
    'Business Development Manager',
    'Wealth Manager',
    'Credit Risk Analyst',
    'Investment Advisor',
    'Blacksmith',
    'Carpenter',
    'Silversmith',
    'Tailor',
    'Weaver',
    'Potter',
    'Cobbler',
    'Jeweler',
    'Butcher',
    'Fisherman',
    'Painter',
    'Shoemaker',
    'Tanner',
    'Locksmith',
    'Stonemason',
    'Glassblower',
    'Cooper',
    'Goldsmith',
    'Housewife',
    'Chartered Accountant (CA)',
    'Human Resources (HR)',
    'Product Manager',
  ],
  [SupportedLanguage.Hindi]: [
    'लेखाकार',
    'अभिनेता',
    'वास्तुकार',
    'कलाकार',
    'बेकर',
    'बैंकर',
    'नाई',
    'बारटेंडर',
    'व्यवसायी',
    'शेफ',
    'सिविल इंजीनियर',
    'दंत चिकित्सक',
    'डॉक्टर',
    'इलेक्ट्रीशियन',
    'इंजीनियर',
    'किसान',
    'अग्निशामक',
    'ग्राफिक डिज़ाइनर',
    'पत्रकार',
    'वकील',
    'पुस्तकालय अध्यक्ष',
    'मैकेनिक',
    'संगीतकार',
    'नर्स',
    'फार्मासिस्ट',
    'फोटोग्राफर',
    'पायलट',
    'प्लम्बर',
    'पुलिस अधिकारी',
    'प्रोफेसर',
    'प्रोग्रामर',
    'वैज्ञानिक',
    'सॉफ्टवेयर डेवलपर',
    'शिक्षक',
    'पशु चिकित्सक',
    'लेखक',
    'भारतीय प्रशासनिक सेवा (IAS) अधिकारी',
    'भारतीय पुलिस सेवा (IPS) अधिकारी',
    'भारतीय विदेश सेवा (IFS) अधिकारी',
    'भारतीय राजस्व सेवा (IRS) अधिकारी',
    'भारतीय वन सेवा (IFoS) अधिकारी',
    'सार्वजनिक क्षेत्र के उपक्रम (PSU) कर्मचारी',
    'रक्षा कर्मी (सेना, नौसेना, वायु सेना)',
    'भारतीय अंतरिक्ष अनुसंधान संगठन (ISRO) में वैज्ञानिक',
    'रक्षा अनुसंधान और विकास संगठन (DRDO) में वैज्ञानिक',
    'सरकारी स्कूल शिक्षक',
    'सरकारी विश्वविद्यालय में प्रोफेसर',
    'सरकारी अस्पताल में डॉक्टर',
    'लोक निर्माण विभाग (PWD) में इंजीनियर',
    'सार्वजनिक क्षेत्र के बैंक में बैंक अधिकारी',
    'रेलवे अधिकारी',
    'सीमा शुल्क अधिकारी',
    'केंद्रीय जांच ब्यूरो (CBI) अधिकारी',
    'आयकर अधिकारी',
    'सार्वजनिक क्षेत्र के उपक्रम (PSU) कार्यकारी',
    'नगर निगम कर्मचारी',
    'बैंक टेलर',
    'ऋण अधिकारी',
    'क्रेडिट विश्लेषक',
    'शाखा प्रबंधक',
    'वित्तीय विश्लेषक',
    'संबंध प्रबंधक',
    'निवेश बैंकर',
    'बंधक सलाहकार',
    'जोखिम प्रबंधक',
    'अनुपालन अधिकारी',
    'ट्रेजरी विश्लेषक',
    'व्यक्तिगत बैंकर',
    'बैंक क्लर्क',
    'वित्तीय योजनाकार',
    'संचालन प्रबंधक',
    'ग्राहक सेवा प्रतिनिधि',
    'व्यवसाय विकास प्रबंधक',
    'धन प्रबंधक',
    'क्रेडिट जोखिम विश्लेषक',
    'निवेश सलाहकार',
    'लोहार',
    'बढ़ई',
    'रजतकार',
    'दर्जी',
    'बुनकर',
    'कुम्हार',
    'मोची',
    'जौहरी',
    'कसाई',
    'बनिया',
    'मछुआरा',
    'चित्रकार',
    'जूता बनाने वाला',
    'चमड़े का काम करने वाला',
    'ताला बनाने वाला',
    'राजमिस्त्री',
    'कांच उड़ाने वाला',
    'पीपे बनाने वाला',
    'सुनार',
    'गृहिणी',
    'चार्टर्ड एकाउंटेंट (सीए)',
    'मानव संसाधन (एचआर)',
    'उत्पाद प्रबंधक',
  ],
  [SupportedLanguage.Marathi]: [
    'लेखापाल',
    'अभिनेता',
    'वास्तुविशारद',
    'कलाकार',
    'बेकरी व्यावसायिक',
    'बँकर',
    'नाई',
    'बारटेंडर',
    'व्यवसायिक',
    'शेफ',
    'सिव्हिल इंजिनियर',
    'दंतवैद्य',
    'डॉक्टर',
    'विद्युत तज्ञ',
    'इंजिनियर',
    'शेतकरी',
    'अग्निशामक',
    'ग्राफिक डिझायनर',
    'पत्रकार',
    'वकील',
    'ग्रंथपाल',
    'मेकॅनिक',
    'संगीतकार',
    'नर्स',
    'फार्मासिस्ट',
    'छायाचित्रकार',
    'वैमानिक',
    'प्लंबर',
    'पोलीस अधिकारी',
    'प्राध्यापक',
    'प्रोग्रामर',
    'शास्त्रज्ञ',
    'सॉफ्टवेअर डेव्हलपर',
    'शिक्षक',
    'प्राणीचिकित्सक',
    'लेखक',
    'भारतीय प्रशासकीय सेवा (IAS) अधिकारी',
    'भारतीय पोलीस सेवा (IPS) अधिकारी',
    'भारतीय परराष्ट्र सेवा (IFS) अधिकारी',
    'भारतीय महसूल सेवा (IRS) अधिकारी',
    'भारतीय वन सेवा (IFoS) अधिकारी',
    'सार्वजनिक क्षेत्रातील उपक्रम (PSU) कर्मचारी',
    'संरक्षण कर्मचारी (सेना, नौदल, वायुसेना)',
    'भारतीय अंतराळ संशोधन संस्था (ISRO) येथे शास्त्रज्ञ',
    'संरक्षण संशोधन आणि विकास संस्था (DRDO) येथे शास्त्रज्ञ',
    'शासकीय शाळेतील शिक्षक',
    'शासकीय विद्यापीठातील प्राध्यापक',
    'शासकीय रुग्णालयातील डॉक्टर',
    'सार्वजनिक बांधकाम विभाग (PWD) मध्ये अभियंता',
    'सार्वजनिक क्षेत्रातील बँकेत बँक अधिकारी',
    'रेल्वे अधिकारी',
    'सीमा शुल्क अधिकारी',
    'केंद्रीय अन्वेषण विभाग (CBI) अधिकारी',
    'आयकर अधिकारी',
    'सार्वजनिक क्षेत्रातील उपक्रम (PSU) कार्यकारी',
    'महानगरपालिका कर्मचारी',
    'बँक टेलर',
    'कर्ज अधिकारी',
    'क्रेडिट विश्लेषक',
    'शाखा व्यवस्थापक',
    'आर्थिक विश्लेषक',
    'संबंध व्यवस्थापक',
    'गुंतवणूक बँकर',
    'गहाण सल्लागार',
    'जोखीम व्यवस्थापक',
    'अनुपालन अधिकारी',
    'खजिना विश्लेषक',
    'वैयक्तिक बँकर',
    'बँक लिपिक',
    'आर्थिक नियोजक',
    'ऑपरेशन्स मॅनेजर',
    'ग्राहक सेवा प्रतिनिधी',
    'व्यवसाय विकास व्यवस्थापक',
    'संपत्ती व्यवस्थापक',
    'क्रेडिट जोखीम विश्लेषक',
    'गुंतवणूक सल्लागार',
    'लोहार',
    'सुतार',
    'चांदीकार',
    'शिंपी',
    'विणकर',
    'कुंभार',
    'चांभार',
    'ज्वेलर',
    'कसाई',
    'मच्छीमार',
    'चित्रकार',
    'बूटमेकर',
    'टॅनर',
    'कुंभार',
    'शिल्पकार',
    'काच फुंकणारा',
    'कूपर',
    'सोनार',
    'गृहिणी',
    'चार्टर्ड अकाउंटंट (CA)',
    'मानव संसाधन (HR)',
    'उत्पादन व्यवस्थापक',
  ],
  [SupportedLanguage.Gujarati]: [
    'એકાઉન્ટન્ટ',
    'અભિનેતા',
    'આર્કિટેક્ટ',
    'કલાકાર',
    'બેકર',
    'બેંકર',
    'નાપિત',
    'બારટેન્ડર',
    'વેપારી',
    'શેફ',
    'સિવિલ ઈજનેર',
    'દંતચિકિત્સક',
    'ડોક્ટર',
    'ઇલેક્ટ્રિશિયન',
    'ઈજનેર',
    'ખેડૂત',
    'ફાયરફાઇટર',
    'ગ્રાફિક ડિઝાઇનર',
    'પત્રકાર',
    'વકીલ',
    'ગ્રંથપાલ',
    'મિકેનિક',
    'સંગીતકાર',
    'નર્સ',
    'ફાર્માસિસ્ટ',
    'ફોટોગ્રાફર',
    'પાયલોટ',
    'પ્લમ્બર',
    'પોલીસ અધિકારી',
    'પ્રોફેસર',
    'પ્રોગ્રામર',
    'વૈજ્ઞાનિક',
    'સોફ્ટવેર ડેવલપર',
    'શિક્ષક',
    'પશુચિકિત્સક',
    'લેખક',
    'ભારતીય પ્રશાસનિક સેવા (IAS) અધિકારી',
    'ભારતીય પોલીસ સેવા (IPS) અધિકારી',
    'ભારતીય વિદેશ સેવા (IFS) અધિકારી',
    'ભારતીય રાજસ્વ સેવા (IRS) અધિકારી',
    'ભારતીય વન સેવા (IFoS) અધિકારી',
    'પબ્લિક સેક્ટર અંડરટેકિંગ (PSU) કર્મચારી',
    'રક્ષા કર્મી (આર્મી, નેવી, એર ફોર્સ)',
    'ભારતીય અવકાશ સંશોધન સંગઠન (ISRO) માં વૈજ્ઞાનિક',
    'રક્ષા સંશોધન અને વિકાસ સંગઠન (DRDO) માં વૈજ્ઞાનિક',
    'સરકારી શાળાના શિક્ષક',
    'સરકારી યુનિવર્સિટીમાં પ્રોફેસર',
    'સરકારી હોસ્પિટલમાં ડોક્ટર',
    'પબ્લિક વર્ક્સ ડિપાર્ટમેન્ટ (PWD) માં ઈજનેર',
    'પબ્લિક સેક્ટર બેંકમાં બેંક ઓફિસર',
    'રેલવે ઓફિસર',
    'કસ્ટમ્સ ઓફિસર',
    'કેન્દ્રીય તપાસ બ્યુરો (CBI) ઓફિસર',
    'આવકવેરા ઓફિસર',
    'પબ્લિક સેક્ટર યુનિટ (PSU) એક્ઝિક્યુટિવ',
    'મ્યુનિસિપલ કોર્પોરેશન કર્મચારી',
    'બેંક ટેલર',
    'લોન ઓફિસર',
    'ક્રેડિટ એનાલિસ્ટ',
    'બ્રાંચ મેનેજર',
    'ફાઇનાન્શિયલ એનાલિસ્ટ',
    'રિલેશનશિપ મેનેજર',
    'ઇન્વેસ્ટમેન્ટ બેંકર',
    'મોર્ટગેજ એડવાઇઝર',
    'રિસ્ક મેનેજર',
    'કમ્પ્લાયન્સ ઓફિસર',
    'ટ્રેઝરી એનાલિસ્ટ',
    'પર્સનલ બેંકર',
    'બેંક ક્લાર્ક',
    'ફાઇનાન્શિયલ પ્લાનર',
    'ઓપરેશન્સ મેનેજર',
    'કસ્ટમર સર્વિસ પ્રતિનિધિ',
    'બિઝનેસ ડેવલપમેન્ટ મેનેજર',
    'વેલ્થ મેનેજર',
    'ક્રેડિટ રિસ્ક એનાલિસ્ટ',
    'ઇન્વેસ્ટમેન્ટ એડવાઇઝર',
    'લોહાર',
    'સુથાર',
    'ચાંદીકામ કારીગર',
    'દરજી',
    'વીણકર',
    'કુંભાર',
    'મોચી',
    'ઝવેરાત કારીગર',
    'કસાઈ',
    'માછીમાર',
    'ચિત્રકાર',
    'જૂતા બનાવનાર',
    'ચામડિયું કામ કરનાર',
    'તાળાં બનાવનાર',
    'પથ્થર કામ કરનાર',
    'કાચ ફૂંકનાર',
    'કૂપર',
    'સોની',
    'ગૃહિણી',
    'ચાર્ટર્ડ એકાઉન્ટન્ટ (CA)',
    'માનવ સંસાધનો (HR)',
    'પ્રોડક્ટ મેનેજર',
  ],
  [SupportedLanguage.Bengali]: [
    'অ্যাকাউন্টেন্ট',
    'অভিনেতা',
    'স্থপতি',
    'শিল্পী',
    'বেকার',
    'ব্যাংকার',
    'বাবার',
    'বারটেন্ডার',
    'ব্যবসায়ী',
    'শেফ',
    'সিভিল ইঞ্জিনিয়ার',
    'দন্ত চিকিৎসক',
    'ডাক্তার',
    'ইলেকট্রিশিয়ান',
    'ইঞ্জিনিয়ার',
    'কৃষক',
    'অগ্নিনির্বাপক',
    'গ্রাফিক ডিজাইনার',
    'সাংবাদিক',
    'আইনজীবী',
    'গ্রন্থাগারিক',
    'মেকানিক',
    'সঙ্গীতজ্ঞ',
    'নার্স',
    'ফার্মাসিস্ট',
    'ফটোগ্রাফার',
    'পাইলট',
    'প্লাম্বার',
    'পুলিশ কর্মকর্তা',
    'প্রফেসর',
    'প্রোগ্রামার',
    'বিজ্ঞানী',
    'সফটওয়্যার ডেভেলপার',
    'শিক্ষক',
    'পশুচিকিৎসক',
    'লেখক',
    'ভারতীয় প্রশাসনিক সেবা (IAS) কর্মকর্তা',
    'ভারতীয় পুলিশ সেবা (IPS) কর্মকর্তা',
    'ভারতীয় বৈদেশিক সেবা (IFS) কর্মকর্তা',
    'ভারতীয় রাজস্ব সেবা (IRS) কর্মকর্তা',
    'ভারতীয় বন সেবা (IFoS) কর্মকর্তা',
    'সরকারি খাত সংস্থা (PSU) কর্মচারী',
    'রক্ষী বাহিনীর কর্মী (সেনা, নৌ, বিমান বাহিনী)',
    'ভারতীয় মহাকাশ গবেষণা সংস্থা (ISRO) বিজ্ঞানী',
    'রক্ষা গবেষণা ও উন্নয়ন সংস্থা (DRDO) বিজ্ঞানী',
    'সরকারি স্কুল শিক্ষক',
    'সরকারি বিশ্ববিদ্যালয়ে প্রফেসর',
    'সরকারি হাসপাতালে ডাক্তার',
    'পাবলিক ওয়ার্কস ডিপার্টমেন্ট (PWD) ইঞ্জিনিয়ার',
    'পাবলিক সেক্টর ব্যাংকের ব্যাংক কর্মকর্তা',
    'রেলওয়ে কর্মকর্তা',
    'কাস্টমস কর্মকর্তা',
    'কেন্দ্রীয় তদন্ত ব্যুরো (CBI) কর্মকর্তা',
    'আয়কর কর্মকর্তা',
    'পাবলিক সেক্টর ইউনিট (PSU) এক্সিকিউটিভ',
    'মিউনিসিপাল কর্পোরেশন কর্মচারী',
    'ব্যাংক টেলার',
    'লোন অফিসার',
    'ক্রেডিট অ্যানালিস্ট',
    'ব্রাঞ্চ ম্যানেজার',
    'আর্থিক অ্যানালিস্ট',
    'রিলেশনশিপ ম্যানেজার',
    'ইনভেস্টমেন্ট ব্যাংকার',
    'মর্গেজ অ্যাডভাইজর',
    'রিস্ক ম্যানেজার',
    'কমপ্লায়েন্স অফিসার',
    'ট্রেজারি অ্যানালিস্ট',
    'পার্সোনাল ব্যাংকার',
    'ব্যাংক ক্লার্ক',
    'আর্থিক পরিকল্পনাকারী',
    'অপারেশন ম্যানেজার',
    'কাস্টমার সার্ভিস রিপ্রেজেন্টেটিভ',
    'ব্যবসায় উন্নয়ন ম্যানেজার',
    'ওয়েলথ ম্যানেজার',
    'ক্রেডিট রিস্ক অ্যানালিস্ট',
    'ইনভেস্টমেন্ট অ্যাডভাইজর',
    'লোহার কাজের কারিগর',
    'কাঠমিস্ত্রী',
    'রূপকার',
    'টেইলার',
    'তাঁতী',
    'মাটির মিস্ত্রী',
    'চামড়ার কাজের কারিগর',
    'গহনা তৈরিকার',
    'মাংস বিক্রেতা',
    'মাছ শিকারি',
    'চিত্রশিল্পী',
    'জুতো সেলাইকারী',
    'চামড়া পালিশকারী',
    'তালার মিস্ত্রী',
    'পাথরের কাজের মিস্ত্রী',
    'কাঁচের কাজের কারিগর',
    'কোপার',
    'সোনার কাজের মিস্ত্রী',
    'গৃহিনী',
    'চার্টার্ড অ্যাকাউন্টেন্ট (CA)',
    'মানবসম্পদ (HR)',
    'প্রোডাক্ট ম্যানেজার',
  ],
  [SupportedLanguage.Tamil]: [
    'கணக்காளர்', // Accountant
    'நடிகர்', // Actor
    'கட்டிடக் கலைஞர்', // Architect
    'கலைஞர்', // Artist
    'அரசன்', // Baker
    'வங்கி அதிகாரி', // Banker
    'முடிக்கடைவர்', // Barber
    'பாட்டில்மேசையாளர்', // Bartender
    'தொழிலதிபர்', // Businessman
    'சமையல்காரர்', // Chef
    'கட்டுமான பொறியாளர்', // Civil Engineer
    'பல் மருத்துவர்', // Dentist
    'மருத்துவர்', // Doctor
    'மின்சாதனப் பொறியாளர்', // Electrician
    'பொறியாளர்', // Engineer
    'விவசாயி', // Farmer
    'தீயணைப்பாளர்', // Firefighter
    'கிராபிக் டிசைனர்', // Graphic Designer
    'செய்தியாளர்', // Journalist
    'வழக்கறிஞர்', // Lawyer
    'நூலகர்', // Librarian
    'இயந்திர வல்லுநர்', // Mechanic
    'இசைக்கலைஞர்', // Musician
    'செவிலியர்', // Nurse
    'மருந்தாளர்', // Pharmacist
    'புகைப்படக் கலைஞர்', // Photographer
    'விமானி', // Pilot
    'குழாய் வல்லுநர்', // Plumber
    'காவல்துறை அதிகாரி', // Police Officer
    'மாநிலக் கல்லூரி பேராசிரியர்', // Professor
    'நிரல் எழுத்தாளர்', // Programmer
    'அறிவியலாளர்', // Scientist
    'மென்பொருள் உருவாக்குனர்', // Software Developer
    'ஆசிரியர்', // Teacher
    'விலங்குகள் மருத்துவர்', // Veterinarian
    'எழுத்தாளர்', // Writer
    'இந்திய நிர்வாக சேவை (IAS) அதிகாரி', // Indian Administrative Service (IAS) Officer
    'இந்திய காவல் சேவை (IPS) அதிகாரி', // Indian Police Service (IPS) Officer
    'இந்திய வெளிநாட்டு சேவை (IFS) அதிகாரி', // Indian Foreign Service (IFS) Officer
    'இந்திய வரி சேவை (IRS) அதிகாரி', // Indian Revenue Service (IRS) Officer
    'இந்திய வன சேவை (IFoS) அதிகாரி', // Indian Forest Service (IFoS) Officer
    'பொது துறை நிறுவன ஊழியர் (PSU)', // Public Sector Undertaking (PSU) Employee
    'பாதுகாப்பு பணியாளர் (இராணுவம், கடற்படை, வான்படை)', // Defense Personnel (Army, Navy, Air Force)
    'இந்திய விண்வெளி ஆராய்ச்சி நிறுவனம் (ISRO) விஞ்ஞானி', // Scientist at Indian Space Research Organisation (ISRO)
    'பாதுகாப்பு ஆராய்ச்சி மற்றும் மேம்பாட்டு நிறுவனம் (DRDO) விஞ்ஞானி', // Scientist at Defence Research and Development Organisation (DRDO)
    'அரசுப் பள்ளி ஆசிரியர்', // Government School Teacher
    'அரசுப் பல்கலைக்கழக பேராசிரியர்', // Professor at Government University
    'அரசு மருத்துவமனை மருத்துவர்', // Doctor in Government Hospital
    'பொது வேலைப்பாடுகள் துறை (PWD) பொறியாளர்', // Engineer in Public Works Department (PWD)
    'அரசு வங்கி அதிகாரி', // Bank Officer in Public Sector Bank
    'ரயில்வே அதிகாரி', // Railway Officer
    'சுங்க அதிகாரி', // Customs Officer
    'மத்திய புலனாய்வு நிறுவனம் (CBI) அதிகாரி', // Central Bureau of Investigation (CBI) Officer
    'வரித்துறை அதிகாரி', // Income Tax Officer
    'பொது துறை நிறுவன (PSU) நிர்வாகி', // Public Sector Unit (PSU) Executive
    'மாநகராட்சி ஊழியர்', // Municipal Corporation Employee
    'வங்கி டெல்லர்', // Bank Teller
    'கடன் அதிகாரி', // Loan Officer
    'கடன் பகுப்பாய்வாளர்', // Credit Analyst
    'கிளை மேலாளர்', // Branch Manager
    'நிதி பகுப்பாய்வாளர்', // Financial Analyst
    'உரிமையாளர் மேலாளர்', // Relationship Manager
    'முதலீட்டுக் வங்கி அதிகாரி', // Investment Banker
    'கடன ஆலோசகர்', // Mortgage Advisor
    'ஆபத்து மேலாளர்', // Risk Manager
    'விதிமுறை அதிகாரி', // Compliance Officer
    'நிதிசேமிப்பு பகுப்பாய்வாளர்', // Treasury Analyst
    'தனிப்பட்ட வங்கி அதிகாரி', // Personal Banker
    'வங்கி எழுத்தர்', // Bank Clerk
    'நிதி திட்டமிடுபவர்', // Financial Planner
    'செயல்பாட்டு மேலாளர்', // Operations Manager
    'வாடிக்கையாளர் சேவை பிரதிநிதி', // Customer Service Representative
    'வணிக வளர்ச்சி மேலாளர்', // Business Development Manager
    'சொத்து மேலாளர்', // Wealth Manager
    'கடன் அபாய பகுப்பாய்வாளர்', // Credit Risk Analyst
    'முதலீட்டு ஆலோசகர்', // Investment Advisor
    'கருமாறுபவர்', // Blacksmith
    'தச்சர்', // Carpenter
    'வெள்ளி நகைக் கலைஞர்', // Silversmith
    'நிகழ்செய்வோர்', // Tailor
    'நூலோடி', // Weaver
    'குயவர்', // Potter
    'பாதரசர்', // Cobbler
    'நகைச்செய்வாளர்', // Jeweler
    'கடைக்காரர்', // Butcher
    'மீனவர்', // Fisherman
    'வண்ணக்காரர்', // Painter
    'பாதரசர்', // Shoemaker
    'துருவாளர்', // Tanner
    'பூட்டுபவர்', // Locksmith
    'கல் செதுக்குபவர்', // Stonemason
    'கண்ணாடி ஊதி', // Glassblower
    'தொட்டான்', // Cooper
    'தங்கச்செய்வாளர்', // Goldsmith
    'வீட்டு மனைவி', // Housewife
    'சார்ட்டர்டு கணக்காளர் (CA)', // Chartered Accountant (CA)
    'மனிதவள மேலாளர் (HR)', // Human Resources (HR)
    'தயாரிப்பு மேலாளர்', // Product Manager
  ],
  [SupportedLanguage.Odia]: [
    'ଅକାଉଣ୍ଟାଣ୍ଟ', // Accountant
    'ଅଭିନେତା', // Actor
    'ସ୍ଥପତି', // Architect
    'ଶିଳ୍ପୀ', // Artist
    'ବେକର', // Baker
    'ବ୍ୟାଙ୍କର', // Banker
    'ନାଇ', // Barber
    'ବାରଟେଣ୍ଡର', // Bartender
    'ବ୍ୟବସାୟୀ', // Businessman
    'ରାନ୍ଧୁଣି', // Chef
    'ସିଭିଲ୍ ଇଞ୍ଜିନିୟର', // Civil Engineer
    'ଦନ୍ତ ଚିକିତ୍ସକ', // Dentist
    'ଡାକ୍ତର', // Doctor
    'ଇଲେକ୍ଟ୍ରିସିଆନ୍', // Electrician
    'ଇଞ୍ଜିନିୟର', // Engineer
    'ଚାଷୀ', // Farmer
    'ଅଗ୍ନିଶାମକ', // Firefighter
    'ଗ୍ରାଫିକ୍ ଡିଜାଇନର', // Graphic Designer
    'ସାମ୍ବାଦିକ', // Journalist
    'ଅଧିବକ୍ତା', // Lawyer
    'ପୁସ୍ତକାଳୟିକ', // Librarian
    'ମେକାନିକ୍', // Mechanic
    'ସଙ୍ଗୀତକାର', // Musician
    'ନର୍ସ', // Nurse
    'ଫାର୍ମାସିଷ୍ଟ', // Pharmacist
    'ଫଟୋଗ୍ରାଫର', // Photographer
    'ପାଇଲଟ୍', // Pilot
    'ପ୍ଲମ୍ବର', // Plumber
    'ପୋଲିସ୍ ଅଫିସର', // Police Officer
    'ପ୍ରୋଫେସର', // Professor
    'ପ୍ରୋଗ୍ରାମର', // Programmer
    'ବୈଜ୍ଞାନିକ', // Scientist
    'ସଫ୍ଟୱେର ଡିଭେଲପର', // Software Developer
    'ଶିକ୍ଷକ', // Teacher
    'ପଶୁ ଚିକିତ୍ସକ', // Veterinarian
    'ଲେଖକ', // Writer
    'ଭାରତୀୟ ପ୍ରଶାସନିକ ସେବା (IAS) ଅଫିସର', // Indian Administrative Service (IAS) Officer
    'ଭାରତୀୟ ପୋଲିସ୍ ସେବା (IPS) ଅଫିସର', // Indian Police Service (IPS) Officer
    'ଭାରତୀୟ ବିଦେଶ ସେବା (IFS) ଅଫିସର', // Indian Foreign Service (IFS) Officer
    'ଭାରତୀୟ ରାଜସ୍ୱ ସେବା (IRS) ଅଫିସର', // Indian Revenue Service (IRS) Officer
    'ଭାରତୀୟ ବନ ସେବା (IFoS) ଅଫିସର', // Indian Forest Service (IFoS) Officer
    'ସାର୍ବଜନିକ ଖଣ୍ଡ ଉଦ୍ୟମ (PSU) କର୍ମଚାରୀ', // Public Sector Undertaking (PSU) Employee
    'ରକ୍ଷା କର୍ମଚାରୀ (ସେନା, ନେଭି, ଏୟାର ଫୋର୍ସ)', // Defense Personnel (Army, Navy, Air Force)
    'ଭାରତୀୟ ଅନ୍ତରିକ୍ଷ ଅନୁସନ୍ଧାନ ସଂସ୍ଥା (ISRO) ରେ ବୈଜ୍ଞାନିକ', // Scientist at Indian Space Research Organisation (ISRO)
    'ରକ୍ଷା ଅନୁସନ୍ଧାନ ଏବଂ ବିକାଶ ସଂସ୍ଥା (DRDO) ରେ ବୈଜ୍ଞାନିକ', // Scientist at Defence Research and Development Organisation (DRDO)
    'ସରକାରୀ ସ୍କୁଲ ଶିକ୍ଷକ', // Government School Teacher
    'ସରକାରୀ ବିଶ୍ୱବିଦ୍ୟାଳୟରେ ପ୍ରୋଫେସର', // Professor at Government University
    'ସରକାରୀ ହସ୍ପିଟାଲରେ ଡାକ୍ତର', // Doctor in Government Hospital
    'ପବ୍ଲିକ୍ ୱର୍କସ୍ ଡିପାର୍ଟମେଣ୍ଟ (PWD) ରେ ଇଞ୍ଜିନିୟର', // Engineer in Public Works Department (PWD)
    'ସାର୍ବଜନିକ ଖଣ୍ଡ ବ୍ୟାଙ୍କରେ ବ୍ୟାଙ୍କ ଅଫିସର', // Bank Officer in Public Sector Bank
    'ରେଲୱେ ଅଫିସର', // Railway Officer
    'କଷ୍ଟମ୍ସ ଅଫିସର', // Customs Officer
    'କେନ୍ଦ୍ରୀୟ ଅନୁସନ୍ଧାନ ବ୍ୟୁରୋ (CBI) ଅଫିସର', // Central Bureau of Investigation (CBI) Officer
    'ଆୟକର ଅଫିସର', // Income Tax Officer
    'ସାର୍ବଜନିକ ଖଣ୍ଡ ଇଉନିଟ୍ (PSU) ଏକ୍ଜିକ୍ୟୁଟିଭ୍', // Public Sector Unit (PSU) Executive
    'ମୁନିସିପାଲ୍ କର୍ପୋରେସନ୍ କର୍ମଚାରୀ', // Municipal Corporation Employee
    'ବ୍ୟାଙ୍କ ଟେଲର', // Bank Teller
    'ଲୋନ୍ ଅଫିସର', // Loan Officer
    'କ୍ରେଡିଟ୍ ଆନାଲିଷ୍ଟ', // Credit Analyst
    'ଶାଖା ପ୍ରବନ୍ଧକ', // Branch Manager
    'ଆର୍ଥିକ ଆନାଲିଷ୍ଟ', // Financial Analyst
    'ସମ୍ପର୍କ ପ୍ରବନ୍ଧକ', // Relationship Manager
    'ନିବେଶ ବ୍ୟାଙ୍କର', // Investment Banker
    'ମର୍ଟଗେଜ୍ ଆଲୋଚକ', // Mortgage Advisor
    'ଝୁକି ପ୍ରବନ୍ଧକ', // Risk Manager
    'ଅନୁପାଳନ ଅଫିସର', // Compliance Officer
    'ଟ୍ରେଜରି ଆନାଲିଷ୍ଟ', // Treasury Analyst
    'ବ୍ୟକ୍ତିଗତ ବ୍ୟାଙ୍କର', // Personal Banker
    'ବ୍ୟାଙ୍କ କ୍ଲାର୍କ', // Bank Clerk
    'ଆର୍ଥିକ ପରିକଳ୍ପନାକାରୀ', // Financial Planner
    'ଅପରେସନ୍ସ୍ ପ୍ରବନ୍ଧକ', // Operations Manager
    'ଗ୍ରାହକ ସେବା ପ୍ରତିନିଧି', // Customer Service Representative
    'ବ୍ୟବସାୟ ବିକାଶ ପ୍ରବନ୍ଧକ', // Business Development Manager
    'ସମ୍ପତ୍ତି ପ୍ରବନ୍ଧକ', // Wealth Manager
    'କ୍ରେଡିଟ୍ ଝୁକି ଆନାଲିଷ୍ଟ', // Credit Risk Analyst
    'ନିବେଶ ଆଲୋଚକ', // Investment Advisor
    'କାଳାକାର', // Blacksmith
    'ବାଡ଼ିକାର', // Carpenter
    'ରୂପକାର', // Silversmith
    'ଦରଜି', // Tailor
    'ବୁଣାକାର', // Weaver
    'କୁମ୍ଭାର', // Potter
    'ଚାମଡ଼ା କାରିଗର', // Cobbler
    'ଜୌହରୀ', // Jeweler
    'କାସାଇ', // Butcher
    'ମାଛ ଧରୁଥିବା ଲୋକ', // Fisherman
    'ଚିତ୍ରକାର', // Painter
    'ଜୁତା ସେଲାଇକାର', // Shoemaker
    'ଚାମଡ଼ା ପାଲିଶକାରୀ', // Tanner
    'ତାଲାକାର', // Locksmith
    'ପଥର କାରିଗର', // Stonemason
    'କାଚ କାରିଗର', // Glassblower
    'କୂପର', // Cooper
    'ସୁନାର', // Goldsmith
    'ଗୃହିଣୀ', // Housewife
    'ଚାର୍ଟର୍ଡ ଅକାଉଣ୍ଟାଣ୍ଟ (CA)', // Chartered Accountant (CA)
    'ମାନବ ସଂସାଧନ (HR)', // Human Resources (HR)
    'ଉତ୍ପାଦ ପ୍ରବନ୍ଧକ', // Product Manager
  ],

  [SupportedLanguage.Telugu]: [
    'అకౌంటెంట్', // Accountant
    'నటుడు', // Actor
    'వాస్తుశిల్పి', // Architect
    'కళాకారుడు', // Artist
    'బేకర్', // Baker
    'బ్యాంకర్', // Banker
    'మంగలి', // Barber
    'బార్టెండర్', // Bartender
    'వ్యాపారి', // Businessman
    'షెఫ్', // Chef
    'సివిల్ ఇంజనీర్', // Civil Engineer
    'దంతవైద్యుడు', // Dentist
    'డాక్టర్', // Doctor
    'ఎలక్ట్రీషియన్', // Electrician
    'ఇంజనీర్', // Engineer
    'రైతు', // Farmer
    'ఫైర్ ఫైటర్', // Firefighter
    'గ్రాఫిక్ డిజైనర్', // Graphic Designer
    'పత్రికా రచయిత', // Journalist
    'న్యాయవాది', // Lawyer
    'గ్రంథపాలకుడు', // Librarian
    'మెకానిక్', // Mechanic
    'సంగీతకారుడు', // Musician
    'నర్సు', // Nurse
    'ఫార్మసిస్ట్', // Pharmacist
    'ఫోటోగ్రాఫర్', // Photographer
    'పైలట్', // Pilot
    'ప్లంబర్', // Plumber
    'పోలీస్ అధికారి', // Police Officer
    'ప్రొఫెసర్', // Professor
    'ప్రోగ్రామర్', // Programmer
    'శాస్త్రవేత్త', // Scientist
    'సాఫ్ట్‌వేర్ డెవలపర్', // Software Developer
    'ఉపాధ్యాయుడు', // Teacher
    'పశువైద్యుడు', // Veterinarian
    'రచయిత', // Writer
    'భారతీయ పరిపాలనా సేవ (IAS) అధికారి', // Indian Administrative Service (IAS) Officer
    'భారతీయ పోలీసు సేవ (IPS) అధికారి', // Indian Police Service (IPS) Officer
    'భారతీయ విదేశీ సేవ (IFS) అధికారి', // Indian Foreign Service (IFS) Officer
    'భారతీయ ఆదాయపు పన్ను సేవ (IRS) అధికారి', // Indian Revenue Service (IRS) Officer
    'భారతీయ అటవీ సేవ (IFoS) అధికారి', // Indian Forest Service (IFoS) Officer
    'ప్రజా రంగ సంస్థ (PSU) ఉద్యోగి', // Public Sector Undertaking (PSU) Employee
    'రక్షణ సిబ్బంది (ఆర్మీ, నేవీ, ఎయిర్ ఫోర్స్)', // Defense Personnel (Army, Navy, Air Force)
    'భారతీయ అంతరిక్ష పరిశోధన సంస్థ (ISRO) శాస్త్రవేత్త', // Scientist at Indian Space Research Organisation (ISRO)
    'రక్షణ పరిశోధన మరియు అభివృద్ధి సంస్థ (DRDO) శాస్త్రవేత్త', // Scientist at Defence Research and Development Organisation (DRDO)
    'ప్రభుత్వ పాఠశాల ఉపాధ్యాయుడు', // Government School Teacher
    'ప్రభుత్వ విశ్వవిద్యాలయంలో ప్రొఫెసర్', // Professor at Government University
    'ప్రభుత్వ ఆసుపత్రిలో డాక్టర్', // Doctor in Government Hospital
    'ప్రజా పనుల విభాగం (PWD) ఇంజనీర్', // Engineer in Public Works Department (PWD)
    'ప్రజా రంగ బ్యాంకులో బ్యాంక్ అధికారి', // Bank Officer in Public Sector Bank
    'రైల్వే అధికారి', // Railway Officer
    'కస్టమ్స్ అధికారి', // Customs Officer
    'కేంద్ర అన్వేషణ బ్యూరో (CBI) అధికారి', // Central Bureau of Investigation (CBI) Officer
    'ఆయకర అధికారి', // Income Tax Officer
    'ప్రజా రంగ యూనిట్ (PSU) ఎగ్జిక్యూటివ్', // Public Sector Unit (PSU) Executive
    'మునిసిపల్ కార్పొరేషన్ ఉద్యోగి', // Municipal Corporation Employee
    'బ్యాంక్ టెల్లర్', // Bank Teller
    'లోన్ అధికారి', // Loan Officer
    'క్రెడిట్ విశ్లేషకుడు', // Credit Analyst
    'శాఖ మేనేజర్', // Branch Manager
    'ఆర్థిక విశ్లేషకుడు', // Financial Analyst
    'సంబంధాల మేనేజర్', // Relationship Manager
    'ఇన్వెస్ట్‌మెంట్ బ్యాంకర్', // Investment Banker
    'మార్గేజ్ సలహాదారు', // Mortgage Advisor
    'రిస్క్ మేనేజర్', // Risk Manager
    'కంప్లయన్స్ అధికారి', // Compliance Officer
    'ట్రెజరీ విశ్లేషకుడు', // Treasury Analyst
    'పర్సనల్ బ్యాంకర్', // Personal Banker
    'బ్యాంక్ క్లర్క్', // Bank Clerk
    'ఆర్థిక ప్రణాళికకర్త', // Financial Planner
    'ఆపరేషన్స్ మేనేజర్', // Operations Manager
    'కస్టమర్ సర్వీస్ ప్రతినిధి', // Customer Service Representative
    'వ్యాపార అభివృద్ధి మేనేజర్', // Business Development Manager
    'వెల్త్ మేనేజర్', // Wealth Manager
    'క్రెడిట్ రిస్క్ విశ్లేషకుడు', // Credit Risk Analyst
    'ఇన్వెస్ట్‌మెంట్ సలహాదారు', // Investment Advisor
    'కమ్మరి', // Blacksmith
    'మరణపు', // Carpenter
    'వెండి నకశా కళాకారుడు', // Silversmith
    'దర్జీ', // Tailor
    'నేత', // Weaver
    'కుమ్మరి', // Potter
    'మోచి', // Cobbler
    'నకశా కళాకారుడు', // Jeweler
    'కసాయి', // Butcher
    'మత్స్యకారుడు', // Fisherman
    'చిత్రకారుడు', // Painter
    'జూతా తయారీదారు', // Shoemaker
    'టానర్', // Tanner
    'తాళాల తయారీదారు', // Locksmith
    'రాయి చెక్కే కళాకారుడు', // Stonemason
    'గాజు ఊదేవాడు', // Glassblower
    'కూపర్', // Cooper
    'బంగారు నకశా కళాకారుడు', // Goldsmith
    'గృహిణి', // Housewife
    'చార్టర్డ్ అకౌంటెంట్ (CA)', // Chartered Accountant (CA)
    'మానవ వనరులు (HR)', // Human Resources (HR)
    'ఉత్పత్తి మేనేజర్', // Product Manager
  ],
  [SupportedLanguage.Kannada]: [
    'ಲೆಕ್ಕಿಗ', // Accountant
    'ನಟ', // Actor
    'ವಾಸ್ತುಶಿಲ್ಪಿ', // Architect
    'ಕಲಾವಿದ', // Artist
    'ಬೇಕರ್', // Baker
    'ಬ್ಯಾಂಕರ್', // Banker
    'ನಾಪಿತ', // Barber
    'ಬಾರ್ಟೆಂಡರ್', // Bartender
    'ವ್ಯಾಪಾರಿ', // Businessman
    'ಶೆಫ್', // Chef
    'ಸಿವಿಲ್ ಇಂಜಿನಿಯರ್', // Civil Engineer
    'ದಂತ ವೈದ್ಯ', // Dentist
    'ಡಾಕ್ಟರ್', // Doctor
    'ವಿದ್ಯುತ್ ತಜ್ಞ', // Electrician
    'ಇಂಜಿನಿಯರ್', // Engineer
    'ರೈತ', // Farmer
    'ಅಗ್ನಿಶಾಮಕ', // Firefighter
    'ಗ್ರಾಫಿಕ್ ಡಿಸೈನರ್', // Graphic Designer
    'ಪತ್ರಕರ್ತ', // Journalist
    'ವಕೀಲ', // Lawyer
    'ಗ್ರಂಥಪಾಲಕ', // Librarian
    'ಯಂತ್ರ ತಜ್ಞ', // Mechanic
    'ಸಂಗೀತಗಾರ', // Musician
    'ನರ್ಸ್', // Nurse
    'ಫಾರ್ಮಸಿಸ್ಟ್', // Pharmacist
    'ಛಾಯಾಗ್ರಾಹಕ', // Photographer
    'ಪೈಲಟ್', // Pilot
    'ಪ್ಲಂಬರ್', // Plumber
    'ಪೊಲೀಸ್ ಅಧಿಕಾರಿ', // Police Officer
    'ಪ್ರೊಫೆಸರ್', // Professor
    'ಪ್ರೋಗ್ರಾಮರ್', // Programmer
    'ವಿಜ್ಞಾನಿ', // Scientist
    'ಸಾಫ್ಟ್‌ವೇರ್ ಡೆವಲಪರ್', // Software Developer
    'ಶಿಕ್ಷಕ', // Teacher
    'ಪಶು ವೈದ್ಯ', // Veterinarian
    'ಲೇಖಕ', // Writer
    'ಭಾರತೀಯ ಆಡಳಿತ ಸೇವೆ (IAS) ಅಧಿಕಾರಿ', // Indian Administrative Service (IAS) Officer
    'ಭಾರತೀಯ ಪೊಲೀಸ್ ಸೇವೆ (IPS) ಅಧಿಕಾರಿ', // Indian Police Service (IPS) Officer
    'ಭಾರತೀಯ ವಿದೇಶಿ ಸೇವೆ (IFS) ಅಧಿಕಾರಿ', // Indian Foreign Service (IFS) Officer
    'ಭಾರತೀಯ ಆದಾಯ ತೆರಿಗೆ ಸೇವೆ (IRS) ಅಧಿಕಾರಿ', // Indian Revenue Service (IRS) Officer
    'ಭಾರತೀಯ ಅರಣ್ಯ ಸೇವೆ (IFoS) ಅಧಿಕಾರಿ', // Indian Forest Service (IFoS) Officer
    'ಸಾರ್ವಜನಿಕ ಕ್ಷೇತ್ರದ ಉದ್ಯಮ (PSU) ನೌಕರ', // Public Sector Undertaking (PSU) Employee
    'ರಕ್ಷಣಾ ಸಿಬ್ಬಂದಿ (ಸೇನೆ, ನೌಕಾಪಡೆ, ವಾಯುಪಡೆ)', // Defense Personnel (Army, Navy, Air Force)
    'ಭಾರತೀಯ ಬಾಹ್ಯಾಕಾಶ ಸಂಶೋಧನಾ ಸಂಸ್ಥೆ (ISRO) ವಿಜ್ಞಾನಿ', // Scientist at Indian Space Research Organisation (ISRO)
    'ರಕ್ಷಣಾ ಸಂಶೋಧನೆ ಮತ್ತು ಅಭಿವೃದ್ಧಿ ಸಂಸ್ಥೆ (DRDO) ವಿಜ್ಞಾನಿ', // Scientist at Defence Research and Development Organisation (DRDO)
    'ಸರ್ಕಾರಿ ಶಾಲಾ ಶಿಕ್ಷಕ', // Government School Teacher
    'ಸರ್ಕಾರಿ ವಿಶ್ವವಿದ್ಯಾಲಯದಲ್ಲಿ ಪ್ರೊಫೆಸರ್', // Professor at Government University
    'ಸರ್ಕಾರಿ ಆಸ್ಪತ್ರೆಯಲ್ಲಿ ಡಾಕ್ಟರ್', // Doctor in Government Hospital
    'ಸಾರ್ವಜನಿಕ ಕಾಮಗಾರಿಗಳ ಇಲಾಖೆ (PWD) ಇಂಜಿನಿಯರ್', // Engineer in Public Works Department (PWD)
    'ಸಾರ್ವಜನಿಕ ಕ್ಷೇತ್ರದ ಬ್ಯಾಂಕಿನಲ್ಲಿ ಬ್ಯಾಂಕ್ ಅಧಿಕಾರಿ', // Bank Officer in Public Sector Bank
    'ರೈಲ್ವೆ ಅಧಿಕಾರಿ', // Railway Officer
    'ಕಸ್ಟಮ್ಸ್ ಅಧಿಕಾರಿ', // Customs Officer
    'ಕೇಂದ್ರ ತನಿಖಾ ದಳ (CBI) ಅಧಿಕಾರಿ', // Central Bureau of Investigation (CBI) Officer
    'ಆದಾಯ ತೆರಿಗೆ ಅಧಿಕಾರಿ', // Income Tax Officer
    'ಸಾರ್ವಜನಿಕ ಕ್ಷೇತ್ರದ ಘಟಕ (PSU) ಕಾರ್ಯನಿರ್ವಾಹಕ', // Public Sector Unit (PSU) Executive
    'ನಗರ ಪಾಲಿಕೆ ನೌಕರ', // Municipal Corporation Employee
    'ಬ್ಯಾಂಕ್ ಟೆಲರ್', // Bank Teller
    'ಕಡನ್ ಅಧಿಕಾರಿ', // Loan Officer
    'ಕ್ರೆಡಿಟ್ ವಿಶ್ಲೇಷಕ', // Credit Analyst
    'ಶಾಖಾ ವ್ಯವಸ್ಥಾಪಕ', // Branch Manager
    'ಆರ್ಥಿಕ ವಿಶ್ಲೇಷಕ', // Financial Analyst
    'ಸಂಬಂಧ ವ್ಯವಸ್ಥಾಪಕ', // Relationship Manager
    'ಹೂಡಿಕೆ ಬ್ಯಾಂಕರ್', // Investment Banker
    'ಮಾರ್ಗೇಜ್ ಸಲಹೆಗಾರ', // Mortgage Advisor
    'ಜೋखिम ನಿರ್ವಾಹಕ', // Risk Manager
    'ಅನುಪಾಲನಾ ಅಧಿಕಾರಿ', // Compliance Officer
    'ಖಜಾನೆ ವಿಶ್ಲೇಷಕ', // Treasury Analyst
    'ವೈಯಕ್ತಿಕ ಬ್ಯಾಂಕರ್', // Personal Banker
    'ಬ್ಯಾಂಕ್ ಕ್ಲರ್ಕ್', // Bank Clerk
    'ಆರ್ಥಿಕ ಯೋಜಕ', // Financial Planner
    'ಆಪರೇಷನ್ಸ್ ಮ್ಯಾನೇಜರ್', // Operations Manager
    'ಗ್ರಾಹಕ ಸೇವಾ ಪ್ರತಿನಿಧಿ', // Customer Service Representative
    'ವ್ಯಾಪಾರ ಅಭಿವೃದ್ಧಿ ವ್ಯವಸ್ಥಾಪಕ', // Business Development Manager
    'ಸಂಪತ್ತು ನಿರ್ವಾಹಕ', // Wealth Manager
    'ಕ್ರೆಡಿಟ್ ರಿಸ್ಕ್ ವಿಶ್ಲೇಷಕ', // Credit Risk Analyst
    'ಹೂಡಿಕೆ ಸಲಹೆಗಾರ', // Investment Advisor
    'ಕಮ್ಮಾರ', // Blacksmith
    'ಮರಣ', // Carpenter
    'ಬೆಳ್ಳಿ ನಕಶೆ ಕಲಾವಿದ', // Silversmith
    'ದರ್ಜೀ', // Tailor
    'ನೇಕಾರ', // Weaver
    'ಕುಂಭಾರ', // Potter
    'ಮೋಚಿ', // Cobbler
    'ನಕಶೆ ಕಲಾವಿದ', // Jeweler
    'ಕಸಾಯಿ', // Butcher
    'ಮೀನುಗಾರ', // Fisherman
    'ಚಿತ್ರಕಾರ', // Painter
    'ಜೂತೆ ತಯಾರಕ', // Shoemaker
    'ಟಾನರ್', // Tanner
    'ತಾಳೆ ತಯಾರಕ', // Locksmith
    'ಕಲ್ಲು ಚಿಕ್ಕುವ ಕಲಾವಿದ', // Stonemason
    'ಗಾಜು ಊದುವವನು', // Glassblower
    'ಕೂಪರ್', // Cooper
    'ಚಿನ್ನದ ನಕಶೆ ಕಲಾವಿದ', // Goldsmith
    'ಗೃಹಿಣಿ', // Housewife
    'ಚಾರ್ಟರ್ಡ್ ಅಕೌಂಟೆಂಟ್ (CA)', // Chartered Accountant (CA)
    'ಮಾನವ ಸಂಪತ್ತು (HR)', // Human Resources (HR)
    'ಉತ್ಪನ್ನ ವ್ಯವಸ್ಥಾಪಕ', // Product Manager
  ],
  [SupportedLanguage.Malayalam]: [
    'അക്കൗണ്ടന്റ്', // Accountant
    'നടൻ', // Actor
    'ആർക്കിടെക്റ്റ്', // Architect
    'കലാകാരൻ', // Artist
    'ബേക്കർ', // Baker
    'ബാങ്കർ', // Banker
    'ബാർബർ', // Barber
    'ബാർടെൻഡർ', // Bartender
    'ബിസിനസ്സുകാരൻ', // Businessman
    'പാചകക്കാരൻ', // Chef
    'സിവിൽ എഞ്ചിനീയർ', // Civil Engineer
    'ദന്തഡോക്ടർ', // Dentist
    'ഡോക്ടർ', // Doctor
    'ഇലക്ട്രീഷ്യൻ', // Electrician
    'എഞ്ചിനീയർ', // Engineer
    'കർഷകൻ', // Farmer
    'അഗ്നിശമന സേനാംഗം', // Firefighter
    'ഗ്രാഫിക് ഡിസൈനർ', // Graphic Designer
    'പത്രപ്രവർത്തകൻ', // Journalist
    'അഭിഭാഷകൻ', // Lawyer
    'ലൈബ്രേറിയൻ', // Librarian
    'മെക്കാനിക്', // Mechanic
    'സംഗീതജ്ഞൻ', // Musician
    'നഴ്സ്', // Nurse
    'ഫാർമസിസ്റ്റ്', // Pharmacist
    'ഫോട്ടോഗ്രാഫർ', // Photographer
    'പൈലറ്റ്', // Pilot
    'പ്ലംബർ', // Plumber
    'പോലീസ് ഓഫീസർ', // Police Officer
    'പ്രൊഫസർ', // Professor
    'പ്രോഗ്രാമർ', // Programmer
    'ശാസ്ത്രജ്ഞൻ', // Scientist
    'സോഫ്റ്റ്വെയർ ഡെവലപ്പർ', // Software Developer
    'അധ്യാപകൻ', // Teacher
    'മൃഗഡോക്ടർ', // Veterinarian
    'എഴുത്തുകാരൻ', // Writer
    'ഇന്ത്യൻ അഡ്മിനിസ്ട്രേറ്റീവ് സർവീസ് (IAS) ഓഫീസർ', // Indian Administrative Service (IAS) Officer
    'ഇന്ത്യൻ പോലീസ് സർവീസ് (IPS) ഓഫീസർ', // Indian Police Service (IPS) Officer
    'ഇന്ത്യൻ ഫോറിൻ സർവീസ് (IFS) ഓഫീസർ', // Indian Foreign Service (IFS) Officer
    'ഇന്ത്യൻ റവന്യൂ സർവീസ് (IRS) ഓഫീസർ', // Indian Revenue Service (IRS) Officer
    'ഇന്ത്യൻ ഫോറസ്റ്റ് സർവീസ് (IFoS) ഓഫീസർ', // Indian Forest Service (IFoS) Officer
    'പൊതുമേഖലാ സ്ഥാപന (PSU) ജീവനക്കാരൻ', // Public Sector Undertaking (PSU) Employee
    'പ്രതിരോധ ജീവനക്കാരൻ (സൈന്യം, നാവികസേന, വ്യോമസേന)', // Defense Personnel (Army, Navy, Air Force)
    'ഇന്ത്യൻ ബഹിരാകാശ ഗവേഷണ സ്ഥാപനത്തിലെ (ISRO) ശാസ്ത്രജ്ഞൻ', // Scientist at Indian Space Research Organisation (ISRO)
    'പ്രതിരോധ ഗവേഷണ വികസന സ്ഥാപനത്തിലെ (DRDO) ശാസ്ത്രജ്ഞൻ', // Scientist at Defence Research and Development Organisation (DRDO)
    'സർക്കാർ സ്കൂൾ അധ്യാപകൻ', // Government School Teacher
    'സർക്കാർ സർവകലാശാല പ്രൊഫസർ', // Professor at Government University
    'സർക്കാർ ആശുപത്രിയിലെ ഡോക്ടർ', // Doctor in Government Hospital
    'പൊതുമരാമത്ത് വകുപ്പിലെ എഞ്ചിനീയർ', // Engineer in Public Works Department (PWD)
    'പൊതുമേഖലാ ബാങ്കിലെ ബാങ്ക് ഓഫീസർ', // Bank Officer in Public Sector Bank
    'റെയിൽവേ ഓഫീസർ', // Railway Officer
    'കസ്റ്റംസ് ഓഫീസർ', // Customs Officer
    'സെൻട്രൽ ബ്യൂറോ ഓഫ് ഇൻവെസ്റ്റിഗേഷൻ (CBI) ഓഫീസർ', // Central Bureau of Investigation (CBI) Officer
    'ആദായ നികുതി ഓഫീസർ', // Income Tax Officer
    'പൊതുമേഖലാ സ്ഥാപന (PSU) എക്സിക്യൂട്ടീവ്', // Public Sector Unit (PSU) Executive
    'മുനിസിപ്പൽ കോർപ്പറേഷൻ ജീവനക്കാരൻ', // Municipal Corporation Employee
    'ബാങ്ക് ടെല്ലർ', // Bank Teller
    'വായ്പാ ഓഫീസർ', // Loan Officer
    'ക്രെഡിറ്റ് അനലിസ്റ്റ്', // Credit Analyst
    'ബ്രാഞ്ച് മാനേജർ', // Branch Manager
    'ഫിനാൻഷ്യൽ അനലിസ്റ്റ്', // Financial Analyst
    'റിലേഷൻഷിപ്പ് മാനേജർ', // Relationship Manager
    'ഇൻവെസ്റ്റ്മെന്റ് ബാങ്കർ', // Investment Banker
    'മോർട്ട്ഗേജ് അഡ്വൈസർ', // Mortgage Advisor
    'റിസ്ക് മാനേജർ', // Risk Manager
    'കംപ്ലയൻസ് ഓഫീസർ', // Compliance Officer
    'ട്രഷറി അനലിസ്റ്റ്', // Treasury Analyst
    'പേഴ്സണൽ ബാങ്കർ', // Personal Banker
    'ബാങ്ക് ക്ലാർക്ക്', // Bank Clerk
    'ഫിനാൻഷ്യൽ പ്ലാനർ', // Financial Planner
    'ഓപ്പറേഷൻസ് മാനേജർ', // Operations Manager
    'കസ്റ്റമർ സർവീസ് റിപ്രസെന്റേറ്റീവ്', // Customer Service Representative
    'ബിസിനസ് ഡെവലപ്മെന്റ് മാനേജർ', // Business Development Manager
    'വെൽത്ത് മാനേജർ', // Wealth Manager
    'ക്രെഡിറ്റ് റിസ്ക് അനലിസ്റ്റ്', // Credit Risk Analyst
    'ഇൻവെസ്റ്റ്മെന്റ് അഡ്വൈസർ', // Investment Advisor
    'കൊല്ലൻ', // Blacksmith
    'ആശാരി', // Carpenter
    'വെള്ളിപ്പണിക്കാരൻ', // Silversmith
    'തയ്യൽക്കാരൻ', // Tailor
    'നെയ്ത്തുകാരൻ', // Weaver
    'കുശവൻ', // Potter
    'ചെരുപ്പുകുത്തി', // Cobbler
    'ആഭരണ പണിക്കാരൻ', // Jeweler
    'കശാപ്പുകാരൻ', // Butcher
    'മീൻപിടുത്തക്കാരൻ', // Fisherman
    'ചിത്രകാരൻ', // Painter
    'ഷൂ നിർമ്മാതാവ്', // Shoemaker
    'ടാനർ', // Tanner
    'പൂട്ടുപണിക്കാരൻ', // Locksmith
    'കല്ലുപണിക്കാരൻ', // Stonemason
    'ഗ്ലാസ് ബ്ലോവർ', // Glassblower
    'കൂപ്പർ', // Cooper
    'സ്വർണ്ണപ്പണിക്കാരൻ', // Goldsmith
    'വീട്ടമ്മ', // Housewife
    'ചാർട്ടേർഡ് അക്കൗണ്ടന്റ് (CA)', // Chartered Accountant (CA)
    'ഹ്യൂമൻ റിസോഴ്സ് (HR)', // Human Resources (HR)
    'പ്രോഡക്റ്റ് മാനേജർ', // Product Manager
  ],
}
